import axios from "axios";
import "url-search-params-polyfill";

const productCache = new Map();

const getProduct = (seriesId, skuId) => {
  const seriesIdParam = seriesId ? `seriesid=${seriesId}` : "";
  const skuIdParam = skuId ? `skuid=${skuId}` : "";
  const joinSeriesAndSku = seriesIdParam && skuIdParam ? "&" : "";

  const url = `/ignitionapi/ProductService/Product?${seriesIdParam}${joinSeriesAndSku}${skuIdParam}`;
  const cacheKey = `${seriesId}-${skuId}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };
  return axios.get(url, config).then(response => {
    productCache.set(cacheKey, response);
    return response;
  });
};

const getProductOptimized = (seriesId, skuId) => {
  const seriesIdParam = seriesId ? `seriesid=${seriesId}` : "";
  const skuIdParam = skuId ? `skuid=${skuId}` : "";
  const joinSeriesAndSku = seriesIdParam && skuIdParam ? "&" : "";

  const url = `/ignitionapi/ProductService/ProductOptimized?${seriesIdParam}${joinSeriesAndSku}${skuIdParam}`;
  const cacheKey = `${seriesId}-${skuId}`;

  if (productCache.has(cacheKey)) {
    return Promise.resolve(productCache.get(cacheKey));
  }

  const config = {
    headers: { Pragma: "no-cache" }
  };

  return axios.get(url, config).then(response => {
    productCache.set(cacheKey, response);
    return response;
  });
};
const getBasicSAPLeadTime = productCode => {
  const productCodeParam = productCode ? `productCode=${productCode}` : "";
  const url = `/ignitionapi/ProductService/GetSAPPriceList?${productCodeParam}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };
  return axios.get(url, config);
};

const getProductUser = () => {
  const url = `/ignitionapi/ProductService/ProductUser`;
  const config = {
    headers: { Pragma: "no-cache" }
  };
  return axios.get(url, config);
};

const ifFromRackShelfFinderPostDetails = (store, cartData) => {
  // if not rackshelf item return
  if (_isFromRackShelfFinder()) {
    _postCustomerRackShelfDetails(store, cartData);
  }
};

// postCustomerRackShelfDetails helpers
// api call
function _postCustomerRackShelfDetails(store, cartData) {
  const url = `/ignitionapi/ProductService/AddCustomerRackShelfDetails`;
  const rackshelfItem = _createRackShelfObject(store, cartData);
  const data = {
    ...rackshelfItem
  };

  return axios.post(url, data);
}

export async function fetchBreadCrumbs(itemId, seriesId) {
  let url = `/ignitionapi/navigation/getbreadcrumb?skuid=${itemId}`;

  if (seriesId && seriesId.trim() !== "" && seriesId !== itemId) {
    url += `&seriesId=${seriesId}`;
  }
  const config = {
    headers: { Pragma: "no-cache" }
  };
  return axios.get(url, config);
}

// check if its a rack shelf item
function _isFromRackShelfFinder() {
  // URLSearchParams is not ie11 compatible
  const rackShelfModelParam = "model";
  const params = new URLSearchParams(window.location.search);
  return params.has(rackShelfModelParam);
}
// make CustomerRackShelf obj
function _createRackShelfObject(store, cartData) {
  const {
    getters: {
      "product/getProduct": {
        SelectedSku: { SkuCode }
      },
      "user/getUser": { CustomerNumber }
    }
  } = store;
  const params = new URLSearchParams(window.location.search);
  const productModel = params.get("model");
  const productMake = params.get("make");
  const { type } = cartData;

  return {
    PartNumber: SkuCode,
    Make: productMake,
    Model: productModel,
    CustomerNumber: CustomerNumber,
    Quantity: 1,
    IsQuote: type === "quote" ? true : false,
    IsSalesOrder: type === "order" ? true : false,
    CreateDate: new Date(),
    UpdatedDate: new Date()
  };
}

export default {
  getProduct,
  getProductOptimized,
  getProductUser,
  getBasicSAPLeadTime,
  ifFromRackShelfFinderPostDetails,
  fetchBreadCrumbs
};
